import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Button, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SelectPipeline } from './SelectPipeline';
import LeadStore from '../../store/LeadStore';
import AuthStore from '../../store/AuthStore';

const CustomButton = styled(Button)({
  backgroundColor: '#FF7959', // Set your desired background color
  color: '#fff', // Set text color
  '&:hover': {
    backgroundColor: '#f1785a', // Set background color on hover
  },
  width: 'fit-content',
});

export const Step1 = observer(({ pipelines, handleStepComplete }) => {
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [showError, setShowError] = useState(false);

  const stepCompleted = () => {
    if (selectedPipeline === null) {
      setShowError(true);
    } else {
      handleStepComplete(selectedPipeline);
    }
  };

  return (
    <>
      <Stack direction={'column'} spacing={2}>
        <div id="step1-header">Select Pipeline</div>
        <p id="step-1-p1">
          Your pipeline is an essential tool for tracking your deals as the progress through the marketing process - all
          the way from first contact, to final construction decision.
        </p>
        <p id="step-1-p2">The first step is to give your pipeline a clear and recognizable name.</p>
      </Stack>
      <Stack direction={'column'} spacing={2}>
        <SelectPipeline
          pipelines={pipelines}
          showError={showError}
          handleSelectedPipeline={setSelectedPipeline}
        ></SelectPipeline>
        <CustomButton variant="contained" onClick={stepCompleted}>
          Next : Define deal stages
        </CustomButton>
      </Stack>
    </>
  );
});
